import {Editor} from 'tinymce';

export const insertContent = (editor: Editor, content: any) => {
  const tinymce = (window as any).tinymce;

  editor.insertContent(tinymce.html.Serializer().serialize(content));
}
